(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tomkat-adapter-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const ids = [65709044203869];
  const eligible = cart => cart.currency === 'GBP' && cart.items.some(i => i.product_id === 16619096572253) && !cart.items.some(i => ids.includes(i.variant_id));
  const signature = cart => JSON.stringify(cart.items.map(i => [i.key,i.quantity]).sort());
  class TomkatAdapterOffer extends HTMLElement {
    static busy = false;
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-book-config]').textContent);
      this.cards = [...this.querySelectorAll('[data-book-id]')];
      this.cards.forEach(card => card.querySelector('button').addEventListener('click', () => this.addBook(card)));
      this.refresh();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    url(path) { return this.config.root.replace(/\/?$/, '/') + path; }
    async read(path) {
      const response = await fetch(this.url(path), {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('read');
      return response.json();
    }
    async refresh() {
      const revision = this.revision = (this.revision || 0) + 1;
      try {
        const cart = await this.read('cart.js');
        const products = await Promise.all(this.cards.map(card => this.read('products/' + card.dataset.bookHandle + '.js')));
        if (!this.isConnected || revision !== this.revision) return;
        this.cards.forEach((card, index) => {
          const variant = products[index].variants.find(v => v.id === Number(card.dataset.bookId));
          card.hidden = !eligible(cart) || !variant?.available || variant.price !== Number(card.dataset.bookPrice);
        });
        this.hidden = this.cards.every(card => card.hidden);
        this.offerSignature = signature(cart);
      } catch { this.hidden = true; }
    }
    async addBook(card) {
      if (TomkatAdapterOffer.busy || card.hidden) return;
      TomkatAdapterOffer.busy = true;
      this.querySelectorAll('button').forEach(button => button.disabled = true);
      const modal = document.createElement('dialog');
      modal.className = 'tk-adapter-progress';
      modal.textContent = this.config.busy;
      modal.addEventListener('cancel', event => event.preventDefault());
      document.body.append(modal);
      modal.showModal();
      try {
        const [before, product] = await Promise.all([this.read('cart.js'),this.read('products/' + card.dataset.bookHandle + '.js')]);
        const id = Number(card.dataset.bookId);
        const variant = product.variants.find(v => v.id === id);
        if (!eligible(before) || signature(before) !== this.offerSignature || !variant?.available || variant.price !== Number(card.dataset.bookPrice)) throw new Error('changed');
        const response = await fetch(this.url('cart/add.js'), {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        if (!response.ok) throw new Error('add');
        const after = await this.read('cart.js');
        const added = after.items.filter(i => i.variant_id === id);
        if (added.reduce((n,i) => n+i.quantity,0) !== 1 || before.items.some(i => !after.items.some(j => j.key === i.key && j.quantity === i.quantity))) throw new Error('verify');
        window.location.assign(this.config.cartUrl);
      } catch {
        this.querySelector('[data-book-status]').textContent = this.config.error;
        this.querySelector('[data-book-review]').hidden = false;
        modal.close(); modal.remove();
        TomkatAdapterOffer.busy = false;
      }
    }
  }
  if (!customElements.get('tomkat-adapter-offer')) customElements.define('tomkat-adapter-offer',TomkatAdapterOffer);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tomkat-book-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const ids = [65698660712797,65698666152285];
  const eligible = cart => !cart.items.some(i => [16623194636637,16625159536989].includes(i.product_id)) && cart.currency === 'GBP' && cart.items.some(i => i.requires_shipping && !ids.includes(i.variant_id)) && !cart.items.some(i => ids.includes(i.variant_id));
  const signature = cart => JSON.stringify(cart.items.map(i => [i.key,i.quantity]).sort());
  class TomkatBookOffer extends HTMLElement {
    static busy = false;
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-book-config]').textContent);
      this.cards = [...this.querySelectorAll('[data-book-id]')];
      this.cards.forEach(card => card.querySelector('button').addEventListener('click', () => this.addBook(card)));
      this.refresh();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    url(path) { return this.config.root.replace(/\/?$/, '/') + path; }
    async read(path) {
      const response = await fetch(this.url(path), {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('read');
      return response.json();
    }
    async refresh() {
      const revision = this.revision = (this.revision || 0) + 1;
      try {
        const cart = await this.read('cart.js');
        const products = await Promise.all(this.cards.map(card => this.read('products/' + card.dataset.bookHandle + '.js')));
        if (!this.isConnected || revision !== this.revision) return;
        this.cards.forEach((card, index) => {
          const variant = products[index].variants.find(v => v.id === Number(card.dataset.bookId));
          card.hidden = !eligible(cart) || !variant?.available || variant.price !== 1000;
        });
        this.hidden = this.cards.every(card => card.hidden);
        this.offerSignature = signature(cart);
      } catch { this.hidden = true; }
    }
    async addBook(card) {
      if (TomkatBookOffer.busy || card.hidden) return;
      TomkatBookOffer.busy = true;
      this.querySelectorAll('button').forEach(button => button.disabled = true);
      const modal = document.createElement('dialog');
      modal.className = 'tk-book-progress';
      modal.textContent = this.config.busy;
      modal.addEventListener('cancel', event => event.preventDefault());
      document.body.append(modal);
      modal.showModal();
      try {
        const [before, product] = await Promise.all([this.read('cart.js'),this.read('products/' + card.dataset.bookHandle + '.js')]);
        const id = Number(card.dataset.bookId);
        const variant = product.variants.find(v => v.id === id);
        if (!eligible(before) || signature(before) !== this.offerSignature || !variant?.available || variant.price !== 1000) throw new Error('changed');
        const response = await fetch(this.url('cart/add.js'), {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        if (!response.ok) throw new Error('add');
        const after = await this.read('cart.js');
        const added = after.items.filter(i => i.variant_id === id);
        if (added.reduce((n,i) => n+i.quantity,0) !== 1 || before.items.some(i => !after.items.some(j => j.key === i.key && j.quantity === i.quantity))) throw new Error('verify');
        window.location.assign(this.config.cartUrl);
      } catch {
        this.querySelector('[data-book-status]').textContent = this.config.error;
        this.querySelector('[data-book-review]').hidden = false;
        modal.close(); modal.remove();
        TomkatBookOffer.busy = false;
      }
    }
  }
  if (!customElements.get('tomkat-book-offer')) customElements.define('tomkat-book-offer',TomkatBookOffer);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tomkat-bundle-upgrade"] && !Shopify.designMode) return;
  try {
    (() => {
    const eligible = (cart, config) => {
      if (!cart || cart.currency !== 'GBP' || cart.total_discount > 0) return null;
      if (cart.items.some(i => i.variant_id === config.bundleId || config.excluded.includes(i.variant_id))) return null;
      if (config.required.length && !cart.items.some(i => config.required.includes(i.variant_id))) return null;
      const lines = cart.items.filter(i => config.components.includes(i.variant_id));
      if (!lines.length || lines.length > config.components.length) return null;
      if (new Set(lines.map(i => i.variant_id)).size !== lines.length) return null;
      if (lines.some(i => !i.key || i.quantity < 1 || Object.keys(i.properties || {}).length || i.selling_plan_allocation || i.parent_relationship || i.item_components?.length || i.line_level_total_discount > 0)) return null;
      return lines;
    };
    const signature = cart => JSON.stringify(cart.items.map(i => [i.key, i.quantity]).sort());
    class TomkatBundleUpgrade extends HTMLElement {
      static busy = false;
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-tk-config]').textContent);
        this.querySelector('[data-tk-title]').textContent = this.config.title;
        this.querySelector('[data-tk-description]').textContent = this.config.description;
        this.querySelector('[data-tk-switch]').textContent = this.config.button;
        this.querySelector('[data-tk-switch]').addEventListener('click', () => this.switchBundle());
        this.refresh();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }
      disconnectedCallback() { this.unsubscribe?.(); }
      url(path) { return this.config.root.replace(/\/?$/, '/') + path; }
      async read(path) {
        const response = await fetch(this.url(path), { cache:'no-store', credentials:'same-origin' });
        if (!response.ok) throw new Error('read');
        return response.json();
      }
      async refresh() {
        if (TomkatBundleUpgrade.busy) return;
        const revision = this.revision = (this.revision || 0) + 1;
        try {
          const [cart, product] = await Promise.all([this.read('cart.js'), this.read('products/' + this.config.bundleHandle + '.js')]);
          if (revision !== this.revision || !this.isConnected) return;
          const lines = eligible(cart, this.config);
          const variant = product.variants.find(v => v.id === this.config.bundleId);
          if (!lines || !variant?.available) { this.hidden = true; return; }
          const money = n => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(n / 100);
          const removed = lines.reduce((sum, i) => sum + i.final_price, 0);
          this.offer = { signature:signature(cart), price:variant.price };
          this.querySelector('[data-tk-price]').textContent = (variant.price >= removed ? this.config.priceAdd : this.config.priceSave).replace('[price]', money(variant.price)).replace('[difference]', money(Math.abs(variant.price - removed)));
          this.hidden = false;
        } catch { this.hidden = true; }
      }
      async switchBundle() {
        if (TomkatBundleUpgrade.busy || !this.offer) return;
        TomkatBundleUpgrade.busy = true;
        const button = this.querySelector('[data-tk-switch]');
        button.disabled = true;
        const modal = document.createElement('dialog');
        modal.className = 'tk-bundle-progress';
        modal.textContent = this.config.busy;
        modal.addEventListener('cancel', event => event.preventDefault());
        document.body.append(modal);
        modal.showModal();
        try {
          const [before, product] = await Promise.all([this.read('cart.js'), this.read('products/' + this.config.bundleHandle + '.js')]);
          const lines = eligible(before, this.config);
          const variant = product.variants.find(v => v.id === this.config.bundleId);
          if (!lines || signature(before) !== this.offer.signature || !variant?.available || variant.price !== this.offer.price) throw new Error('changed');
          const updates = Object.fromEntries(lines.map(i => [i.key, i.quantity - 1]));
          updates[this.config.bundleId] = 1;
          const response = await fetch(this.url('cart/update.js'), { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates}) });
          if (!response.ok) throw new Error('update');
          const after = await this.read('cart.js');
          const expected = new Map();
          for (const line of before.items) expected.set(line.variant_id, (expected.get(line.variant_id) || 0) + line.quantity);
          for (const line of lines) expected.set(line.variant_id, line.quantity - 1);
          expected.set(this.config.bundleId, 1);
          const actual = new Map();
          for (const line of after.items) actual.set(line.variant_id, (actual.get(line.variant_id) || 0) + line.quantity);
          if ([...expected].some(([id, quantity]) => (actual.get(id) || 0) !== quantity) || [...actual].some(([id]) => !expected.has(id))) throw new Error('verify');
          window.location.assign(this.config.cartUrl);
        } catch {
          this.querySelector('[data-tk-status]').textContent = this.config.error;
          this.querySelector('[data-tk-review]').hidden = false;
          button.hidden = true;
          modal.close();
          modal.remove();
          TomkatBundleUpgrade.busy = false;
        }
      }
    }
    if (!customElements.get('tomkat-bundle-upgrade')) customElements.define('tomkat-bundle-upgrade', TomkatBundleUpgrade);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tomkat-pipe-manual-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const eligible = (cart, id) => {
    const products = id === 66125021708637 ? [16641842282845,16641977549149] : id === 66125021544797 ? [16623194636637,16625159536989,16623803760989] : [];
    return cart.currency === 'GBP' && cart.items.some(i => products.includes(i.product_id)) && !cart.items.some(i => i.variant_id === id);
  };
  const signature = cart => JSON.stringify(cart.items.map(i => [i.key,i.quantity]).sort());
  class TomkatPipeManualOffer extends HTMLElement {
    static busy = false;
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-book-config]').textContent);
      this.cards = [...this.querySelectorAll('[data-book-id]')];
      this.cards.forEach(card => card.querySelector('button').addEventListener('click', () => this.addBook(card)));
      this.refresh();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    url(path) { return this.config.root.replace(/\/?$/, '/') + path; }
    async read(path) {
      const response = await fetch(this.url(path), {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('read');
      return response.json();
    }
    async refresh() {
      const revision = this.revision = (this.revision || 0) + 1;
      try {
        const cart = await this.read('cart.js');
        const products = await Promise.all(this.cards.map(card => this.read('products/' + card.dataset.bookHandle + '.js')));
        if (!this.isConnected || revision !== this.revision) return;
        this.cards.forEach((card, index) => {
          const variant = products[index].variants.find(v => v.id === Number(card.dataset.bookId));
          card.hidden = !eligible(cart, Number(card.dataset.bookId)) || !variant?.available || variant.price !== Number(card.dataset.bookPrice);
        });
        this.hidden = this.cards.every(card => card.hidden);
        const workbook = cart.items.some(i => i.product_id === 16625159536989);
        const sheet = cart.items.some(i => i.product_id === 16623194636637);
        const installation = cart.items.some(i => i.product_id === 16623803760989);
        const lpg = cart.items.some(i => [16641842282845,16641977549149].includes(i.product_id));
        this.querySelector('[data-lpg-notice]').hidden = !lpg;
        this.querySelector('[data-offer-heading]').textContent = lpg ? (sheet || workbook || installation ? this.config.mixedHeading : this.config.lpgHeading) : (sheet || workbook ? this.config.pipeHeading : this.config.referenceHeading);
        this.querySelector('[data-sheet-notice]').hidden = !sheet;
        this.querySelector('[data-installation-notice]').hidden = !installation;
        this.querySelector('[data-workbook-notice]').hidden = !workbook;
        this.offerSignature = signature(cart);
      } catch { this.hidden = true; }
    }
    async addBook(card) {
      if (TomkatPipeManualOffer.busy || card.hidden) return;
      TomkatPipeManualOffer.busy = true;
      this.querySelectorAll('button').forEach(button => button.disabled = true);
      const modal = document.createElement('dialog');
      modal.className = 'tk-pipe-book-progress';
      modal.textContent = this.config.busy;
      modal.addEventListener('cancel', event => event.preventDefault());
      document.body.append(modal);
      modal.showModal();
      try {
        const [before, product] = await Promise.all([this.read('cart.js'),this.read('products/' + card.dataset.bookHandle + '.js')]);
        const id = Number(card.dataset.bookId);
        const variant = product.variants.find(v => v.id === id);
        if (!eligible(before, id) || signature(before) !== this.offerSignature || !variant?.available || variant.price !== Number(card.dataset.bookPrice)) throw new Error('changed');
        const response = await fetch(this.url('cart/add.js'), {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        if (!response.ok) throw new Error('add');
        const after = await this.read('cart.js');
        const added = after.items.filter(i => i.variant_id === id);
        if (added.reduce((n,i) => n+i.quantity,0) !== 1 || before.items.some(i => !after.items.some(j => j.key === i.key && j.quantity === i.quantity))) throw new Error('verify');
        window.location.assign(this.config.cartUrl);
      } catch {
        this.querySelector('[data-book-status]').textContent = this.config.error;
        this.querySelector('[data-book-review]').hidden = false;
        modal.close(); modal.remove();
        TomkatPipeManualOffer.busy = false;
      }
    }
  }
  if (!customElements.get('tomkat-pipe-manual-offer')) customElements.define('tomkat-pipe-manual-offer',TomkatPipeManualOffer);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tomkat-training-groups"] && !Shopify.designMode) return;
  try {
    (()=>{const root=document.querySelector('[data-tk-updates]');if(!root||root.dataset.bound)return;root.dataset.bound='true';const panel=root.querySelector('.tk-updates-panel'),open=root.querySelector('.tk-updates-open'),key='tk-updates-dismiss-until';let suppressed=false;try{suppressed=Number(localStorage.getItem(key))>Date.now()}catch(e){}const show=()=>{panel.hidden=false;open.hidden=true;open.setAttribute('aria-expanded','true')};const hide=()=>{panel.hidden=true;open.hidden=false;open.setAttribute('aria-expanded','false');suppressed=true;try{localStorage.setItem(key,String(Date.now()+30*86400000))}catch(e){}};open.addEventListener('click',()=>{show();root.querySelector('input[type=email]').focus()});root.querySelector('[data-dismiss]').addEventListener('click',hide);root.querySelector('[data-subscribed]').addEventListener('click',hide);if(root.dataset.mode==='download'){if(!suppressed)show()}else{const start=Date.now();const check=()=>{if(suppressed)return;if(Date.now()-start>=15000&&window.scrollY>250){show();window.removeEventListener('scroll',check)}};window.addEventListener('scroll',check,{passive:true});setTimeout(check,15000)}root.querySelector('form').addEventListener('submit',async event=>{event.preventDefault();const form=event.currentTarget,button=form.querySelector('[type=submit]'),status=form.querySelector('[role=status]');if(button.disabled)return;button.disabled=true;status.hidden=true;try{const response=await fetch(form.action,{method:'POST',body:new URLSearchParams(new FormData(form)),credentials:'omit'});const result=await response.json();if(!response.ok||result.success!==true)throw new Error('Signup failed');status.textContent=status.dataset.success;status.hidden=false;suppressed=true;try{localStorage.setItem(key,String(Date.now()+30*86400000))}catch(e){}form.querySelector('input[type=email]').value=''}catch(e){status.textContent=status.dataset.error;status.hidden=false;form.querySelector('.tk-updates-fallback').hidden=false}finally{button.disabled=false}})})();
  } catch(e) { console.error(e); }
})();

})();
